module.exports = __webpack_public_path__ + "media/images/lb/923-cd8df4905d0d5e0e00d67a32af472291.svg";